<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VInputReadonlyWithLabel from "@/Shared/Form/VInputReadonlyWithLabel.vue";

import VModal from "@/Shared/VModal.vue";
import { ref } from "vue";
import VTextareaWithLabelShow from "../../../../Shared/Form/VTextareaWithLabelShow.vue";

const props = defineProps({
    type: String,
    user: Object,
    roles: Array,

    urlSubmit: String,
    urlUpdateCreds: String,

    method: String,
});

const emits = defineEmits(["onSave", "onCancel"]);

const refModal = ref(null);

const title = "Detail User";

const cancel = () => {
    emits("onCancel");
};
</script>
<template>
    <VModal ref="refModal" :title="title" size="modal-md" @onClose="cancel">
        <template v-slot:body>
            <div class="m-3">
                <div class="row">
                    <div class="col-12">
                        <VInputReadonlyWithLabel
                            label="Name"
                            :value="user.name"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <VInputReadonlyWithLabel
                            label="Roles"
                            :value="
                                user.roles?.map((item) => item.name).join(',')
                            "
                        />
                    </div>
                    <div class="col-12">
                        <VInputReadonlyWithLabel
                            label="Status"
                            :value="user.status_text"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <VTextareaWithLabelShow
                            elId="api_key"
                            label="API KEY"
                            :value="user.api_key"
                            :isPlainText="false"
                        />
                    </div>
                </div>

                <VDevider class="my-4" />

                <div class="row">
                    <div class="col-12 mb-3">
                        <VInputReadonlyWithLabel
                            label="Email"
                            :value="user.email"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="text-end"></div>
        </template>
    </VModal>
</template>
